import { AppRoutes } from 'AppRoutes';
import { ActivityTracker } from 'components/ActivityTracker';
import { SubscribeProvider } from 'context/Subscribe-context';
import { CookieConsentProvider } from 'context/cookie-consent-context';

declare global {
  interface Window {
    __REACT_DEVTOOLS_GLOBAL_HOOK__?: any;
  }
}

function App() {
/* eslint-disable @typescript-eslint/no-empty-function */
if (process.env.REACT_APP_ENV === "Production" || process.env.REACT_APP_ENV === "staging") {
  if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = () => {};
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__ = undefined;
  }
}
/* eslint-enable @typescript-eslint/no-empty-function */

  return (
    <CookieConsentProvider>
      <SubscribeProvider>
        <ActivityTracker />
        <AppRoutes />
      </SubscribeProvider>
    </CookieConsentProvider>
  );
}

export default App;
